import _styled from "styled-components";
import { useMemo, useRef, useCallback, useState } from 'react';
import AliceCarousel from 'react-alice-carousel';
import Image from 'next/image';
import { Button as FlowBiteButton } from 'flowbite-react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { customImageLoader, useMounted } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ImageCarousel = function ImageCarousel(_ref) {
  var restaurantPictures = _ref.restaurantPictures,
      variant = _ref.variant;
  var carouselRef = useRef(null);
  var isMounted = useMounted();
  var items = useImageCarouselList({
    restaurantPictures: restaurantPictures,
    isMounted: isMounted,
    variant: variant
  });

  var _useActiveIndex = useActiveIndex(),
      _onSlideChanged = _useActiveIndex.onSlideChanged,
      activeIndex = _useActiveIndex.activeIndex;

  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(AliceCarousel, {
      activeIndex: activeIndex,
      onSlideChanged: function onSlideChanged(e) {
        return _onSlideChanged(e.item);
      },
      disableButtonsControls: true,
      disableDotsControls: true,
      touchTracking: true,
      mouseTracking: true,
      ref: carouselRef,
      controlsStrategy: "alternate",
      items: items,
      responsive: {
        0: {
          items: variant === 'showcase' ? 1.1 : 1.2
        },
        768: {
          items: variant === 'showcase' ? 1.1 : 3
        }
      }
    }), items.length > 1 && /*#__PURE__*/_jsx(CarouselNavigation, {
      carouselRef: carouselRef
    })]
  });
};
export default ImageCarousel; // --> types

export var CarouselNavigation = function CarouselNavigation(_ref2) {
  var carouselRef = _ref2.carouselRef;
  var navigate = ['prev', 'next'];
  var carouselNavigationHandler = useCallback(function (e, navigate) {
    var _carouselRef$current, _carouselRef$current2;

    e.preventDefault();
    if (navigate === 'prev') carouselRef === null || carouselRef === void 0 ? void 0 : (_carouselRef$current = carouselRef.current) === null || _carouselRef$current === void 0 ? void 0 : _carouselRef$current.slidePrev(e);else carouselRef === null || carouselRef === void 0 ? void 0 : (_carouselRef$current2 = carouselRef.current) === null || _carouselRef$current2 === void 0 ? void 0 : _carouselRef$current2.slideNext(e);
  }, [carouselRef]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: navigate.map(function (role) {
      return /*#__PURE__*/_jsx(NavigationButton, {
        navigate: role,
        onClick: function onClick(e) {
          return carouselNavigationHandler(e, role);
        },
        children: role === navigate[0] ? /*#__PURE__*/_jsx(ChevronLeftIcon, {
          className: "h-5"
        }) : /*#__PURE__*/_jsx(ChevronRightIcon, {
          className: "h-5"
        })
      }, role);
    })
  });
}; // parent --> child components

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "image-carousel__Wrapper",
  componentId: "sc-19sg58h-0"
})({
  "position": "relative",
  "width": "100%",
  "@media (min-width: 768px)": {
    "margin": "0px"
  }
});

var NavigationButton = /*#__PURE__*/_styled(FlowBiteButton).withConfig({
  displayName: "image-carousel__NavigationButton",
  componentId: "sc-19sg58h-1"
})(["", " ", " ", ""], {
  "position": "absolute",
  "top": "44%",
  "--tw-translate-y": "-50%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
}, {
  "height": "2rem",
  "width": "2rem",
  "borderRadius": "9999px",
  "backgroundColor": "rgb(75 85 99 / 0.3)",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  ":hover": {
    "backgroundColor": "rgb(75 85 99 / 0.5)"
  },
  ":focus": {
    "outline": "2px solid transparent",
    "outlineOffset": "2px"
  },
  "@media (min-width: 640px)": {
    "height": "2.5rem",
    "width": "2.5rem"
  }
}, function (_ref3) {
  var navigate = _ref3.navigate;
  return navigate === 'prev' ? {
    "left": "0.875rem"
  } : {
    "right": "0.875rem"
  };
});

var useImageCarouselList = function useImageCarouselList(_ref4) {
  var restaurantPictures = _ref4.restaurantPictures,
      isMounted = _ref4.isMounted,
      variant = _ref4.variant;

  var handleDragStart = function handleDragStart(e) {
    return e.preventDefault();
  };

  var items = useMemo(function () {
    return restaurantPictures.map(function (image, i) {
      return /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(StyledImage, {
          loader: customImageLoader,
          "data-value": i + 1,
          className: "item",
          alt: "".concat('img' + i),
          src: image,
          onDragStart: handleDragStart,
          width: 300,
          height: 300,
          variant: variant
        })
      }, image);
    });
  }, [restaurantPictures, variant]);
  return isMounted ? items : [];
};

export var useActiveIndex = function useActiveIndex() {
  var defaultIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _useState = useState(defaultIndex),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var onSlideChanged = useCallback(function (index) {
    return setActiveIndex(index);
  }, []);
  return {
    activeIndex: activeIndex,
    onSlideChanged: onSlideChanged
  };
};

var StyledImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "image-carousel__StyledImage",
  componentId: "sc-19sg58h-2"
})(function (_ref5) {
  var variant = _ref5.variant;
  return [{
    "height": "13rem",
    "borderRadius": "0.5rem",
    "objectFit": "cover",
    "paddingLeft": "0.25rem",
    "paddingRight": "0.25rem"
  }, variant === 'showcase' && {
    "height": "27.188rem",
    "width": "100%",
    "minWidth": "100%",
    "borderRadius": "0.938rem",
    "paddingLeft": "0px",
    "paddingRight": "0px"
  }];
});